import React, { Component } from 'react';
import { imagePath } from "../../Utils/Retail/helpers.js";
import "../../css/popupPatch.css";
const PopupPatch = ({
    stickerDimensions,
    message
}) => {
    return (
        <div className="popup-patch-container" style={{
            backgroundImage: `url('${imagePath}/alert_patch.png')`,
            width: stickerDimensions[0],
            height: stickerDimensions[1]
        }}>
            <div className="bottom-white-space" style={{
                marginBottom: Math.round(stickerDimensions[1]*0.2)
            }}>
                <div className="text-content" dangerouslySetInnerHTML={{
                    __html: message,
                }}
                // Inline style for better responsive text
                style={{
                    fontSize: window.innerWidth > 575 ?
                            Math.ceil(0.06 * stickerDimensions[0]) :
                            Math.ceil(0.05 * stickerDimensions[0])
                    ,
                    lineHeight: '1'
                }}
                >
                </div>
            </div>
        </div>
    );
}
 
export default PopupPatch;